import bizStore from './store/index'
import components from './components/index'
import modules from './modules/index'
import bizAjax from './store/ajax'
import bizMixins from './mixins'

const install = function (Vue) {
  for (let name in components) {
    let component = components[name]
    component.install(Vue)
  }
  for (let name in modules) {
    let module = modules[name]
    module.install(Vue)
  }
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
let bizComponents = {
  install
}
let bizModules = {
  install
}
export {
  bizAjax,
  bizStore,
  bizComponents,
  bizModules,
  bizMixins
}
